﻿import { onEvent } from "./_dom";

function setValue(event, trigger, newValue) {
	const id = trigger.dataset.setvalueFor;
	const input = document.getElementById(id);
	if (input) {
		event.preventDefault();
		if (input.value !== newValue) {
			input.value = newValue;
			input.dispatchEvent(new Event("change", { bubbles: true }));
		}
	}
}

function init(context) {
	onEvent(context, "a[data-setvalue-for]", "click", (event, link) => {
		const newValue = link.dataset.value;
		setValue(event, link, newValue);
	});
	onEvent(context, "input[type=radio][data-setvalue-for]", "click", (event, radio) => {
		const newValue = radio.value;
		setValue(event, radio, newValue);
	});
	onEvent(context, "select[data-setvalue-for]", "change", (event, select) => {
		const newValue = select.value;
		setValue(event, select, newValue);
	});
}

export { init };